import { toast } from 'react-toastify'
import URL from 'src/apis/URL'

// Action Types
export const GET_TAX_INVOICES_REQUEST = 'GET_TAX_INVOICES_REQUEST'
export const GET_TAX_INVOICES_SUCCESS = 'GET_TAX_INVOICES_SUCCESS'
export const GET_CUSTOMER_INVOICE_SUCCESS = 'GET_CUSTOMER_INVOICE_SUCCESS'
export const GET_TAX_INVOICES_FAILURE = 'GET_TAX_INVOICES_FAILURE'

// Action Creators
export const getTaxInvoicesRequest = () => ({
  type: GET_TAX_INVOICES_REQUEST,
})

export const getTaxInvoicesSuccess = (data) => ({
  type: GET_TAX_INVOICES_SUCCESS,
  data,
})

export const getCustomerInvoiceSuccess = (data) => ({
  type: GET_CUSTOMER_INVOICE_SUCCESS,
  data,
})

export const getTaxInvoicesFailure = (error) => ({
  type: GET_TAX_INVOICES_FAILURE,
  error,
})

// Thunk to get all tax invoices by date range
export const getTaxInvoices = (startDate, endDate) => {
  return (dispatch) => {
    dispatch(getTaxInvoicesRequest())

    fetch(
      `${URL.BASE_URL + URL.END_POINT.customerinvoice}?start_date=${startDate}&end_date=${endDate}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          USERID: localStorage.getItem('USERID'),
          Authorization: `Bearer token=${localStorage.getItem('token')}`,
        },
      },
    )
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        return response.json()
      })
      .then((data) => {
        dispatch(getTaxInvoicesSuccess(data))
      })
      .catch((error) => {
        dispatch(getTaxInvoicesFailure(error.message))
        toast(error.message, { type: 'error' })
      })
  }
}

// Thunk to get a single customer invoice by username and order number
export const getCustomerInvoice = (username, order_no) => {
  return (dispatch) => {
    dispatch(getTaxInvoicesRequest())

    fetch(
      `${URL.BASE_URL + URL.END_POINT.customerinvoice}?username=${username}&order_no=${order_no}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          USERID: localStorage.getItem('USERID'),
          Authorization: `Bearer token=${localStorage.getItem('token')}`,
        },
      },
    )
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        return response.json()
      })
      .then((data) => {
        dispatch(getCustomerInvoiceSuccess(data))
      })
      .catch((error) => {
        dispatch(getTaxInvoicesFailure(error.message))
        toast(error.message, { type: 'error' })
      })
  }
}

// Initial State
const initialInvoiceState = {
  invoiceData: [],
  invoices: [],
  loadingInvoices: false,
  invoiceError: null,
}

// Reducer
export const taxInvoiceReducer = (state = initialInvoiceState, action) => {
  switch (action.type) {
    case GET_TAX_INVOICES_REQUEST:
      return {
        ...state,
        loadingInvoices: true,
        invoiceError: null,
      }

    case GET_TAX_INVOICES_SUCCESS:
      return {
        ...state,
        invoiceData: action.data.invoiceData || [],
        invoices: action.data.invoices || [],
        loadingInvoices: false,
        invoiceError: null,
      }

    case GET_CUSTOMER_INVOICE_SUCCESS:
      return {
        ...state,
        invoiceData: action.data.invoiceData || [],
        // Don't update invoices here — keep existing list
        loadingInvoices: false,
        invoiceError: null,
      }

    case GET_TAX_INVOICES_FAILURE:
      return {
        ...state,
        loadingInvoices: false,
        invoiceError: action.error,
      }

    default:
      return state
  }
}
